import { z } from "zod";

export const pollVoteSchema = z
	.object({
		option_id: z.string().uuid({ message: "Invalid option ID" }),
	})
	.strict();

export type PollVotePayload = z.infer<typeof pollVoteSchema>;
